export default "/assets/Icon/MetaMask.svg"